import { useCallback } from 'react';
import logger from 'ws-scripts/modules/logger';

const LOG_PREFIX = '[ws-locations-control][useFilterVisibility]';
const FILTER_TOPIC = 'ws-locations-data/filter-visibility';

/**
 * Hook that publishes filter visibility state through DDC pubsub.
 *
 * @returns {{ publishVisibility: (visible: boolean) => void }}
 */
export const usePublishFilterVisibility = () => {
	const publishVisibility = useCallback((visible) => {
		try {
			const pubsub = window.DDC?.pubsub;
			if (!pubsub) {
				logger.warn(`${LOG_PREFIX} DDC.pubsub not available`);
				return;
			}
			pubsub.publish(FILTER_TOPIC, { visible });
		} catch (error) {
			logger.error(
				`${LOG_PREFIX} Failed to publish filter visibility:`,
				error
			);
		}
	}, []);

	return { publishVisibility };
};

/**
 * Hook that subscribes to filter visibility state changes through DDC pubsub.
 *
 * @returns {{ subscribeToVisibility: (callback: (visible: boolean) => void) => () => void }}
 */
export const useSubscribeFilterVisibility = () => {
	const subscribeToVisibility = useCallback((callback) => {
		try {
			const pubsub = window.DDC?.pubsub;
			if (!pubsub) {
				logger.warn(`${LOG_PREFIX} DDC.pubsub not available`);
				return () => {};
			}
			const subscription = pubsub.subscribe(FILTER_TOPIC, (data) => {
				if (data && typeof data.visible === 'boolean') {
					callback(data.visible);
				}
			});
			return () => pubsub.unsubscribe(subscription);
		} catch (error) {
			logger.error(
				`${LOG_PREFIX} Failed to subscribe to filter visibility:`,
				error
			);
			return () => {};
		}
	}, []);

	return { subscribeToVisibility };
};
